// Copied from @passkeys/ui/fancy-amount due to colors being significantly different.
// TODO: Unify back once colors are solved.

import { formatValue } from '@/ui/components/wallet-snapshot/utils';
import { cn } from '@/ui/utils/classnames';

export interface FancyAmountProps {
  value: number | null;
  fontSize: 18 | 28;
  className?: string;
}

function FancyAmount({ value, className, fontSize }: FancyAmountProps) {
  const { symbol, integerDigits, fractionDigits } = formatValue(value);

  const smallerFontSize = 22;

  return (
    <h1
      className={cn(
        'flex items-baseline font-medium leading-none',
        'text-[color:var(--collapsed-text-color,_theme(colors.black))]',
        className,
      )}
      style={{ fontSize }}
    >
      <span className="mr-0.5">{symbol}</span>
      <span>{integerDigits}</span>

      {fractionDigits && (
        <span
          className="leading-none text-[color:var(--collapsed-text-color,_theme(colors.black))] opacity-[--collapsed-text-opacity,1]"
          style={{ fontSize: fontSize === 18 ? fontSize : smallerFontSize }}
        >
          {fractionDigits}
        </span>
      )}
    </h1>
  );
}

export default FancyAmount;
